import DeleteVehicle from "./DeleteVehicle";

export default DeleteVehicle;
